module.exports = __webpack_public_path__ + "static/media/jio-money.ad71c228.png";